
import * as actionTypes from "../types";

const initialState = {
    recommendation : {}
}

const setRecommendation = (state = initialState,action) => {
    switch(action.type) {
        case actionTypes.QALARA_RECOMMENDATION :
            return {
                ...state,
                recommendation : action.payload   
            }
        default : 
            return state
    }
}

export default setRecommendation